import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

const CourseLiveListMine = () => import('../views/course-live/CourseLiveListMine.vue')
const CourseLiveCreateStep1 = () => import('../views/course-live/CourseLiveCreateStep1.vue')
const CourseLiveCreateStep2 = () => import('../views/course-live/CourseLiveCreateStep2.vue')
const CourseLiveDetail = () => import('../views/course-live/CourseLiveDetail.vue')
const CourseLiveStatistics = () => import('../views/course-live/CourseLiveStatistics.vue')

export const MineCourseListRoute: RouteConfig = {
  path: '/course-live-mine',

  name: 'course_live_mine',

  component: CourseLiveListMine,

  meta: {
    title: '我的体育课',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const OnlineCourseCreateStep2Route: RouteConfig = {
  path: '/course-live-create-step-2',
  name: 'course_live_create_step_2',
  component: CourseLiveCreateStep2,
  props: (route) => ({
    ...route.query,
    ...route.params,
    backLevel: Number(route.query.backLevel),
    currentStep: Number(route.query.currentStep) || 2,
    totalSteps: Number(route.query.totalSteps) || 2,
  }),

  meta: {
    title: '发布在线课',
    stepTitle: '发布课程',
    nextButtonText: '确认布置',
  },
}

export const OnlineCourseCreateStep1Route: RouteConfig = {
  path: '/course-live-create-step-1',
  name: 'course_live_create_step_1',
  component: CourseLiveCreateStep1,
  props: (route) => ({
    ...route.query,
    ...route.params,
    backLevel: Number(route.query.backLevel),
    currentStep: Number(route.query.currentStep) || 1,
    totalSteps: Number(route.query.totalSteps) || 2,
  }),

  meta: {
    title: '选择课程',
    stepTitle: '选择课程',
    nextStep: OnlineCourseCreateStep2Route.name,
  },
}

export const CourseLiveDetailRoute: RouteConfig = {
  path: '/course-live-detail',
  name: 'course_live_detail',
  component: CourseLiveDetail,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),

  meta: {
    title: '课程详情',
  },
}

export const CourseLiveStatisticsRoute: RouteConfig = {
  path: '/course-live-statistics',
  name: 'course_live_statistics',
  component: CourseLiveStatistics,
  props: (route) => ({
    ...route.query,
    ...route.params,
  }),

  meta: {
    title: '课程统计',
  },
}

const RCourseLive: RouteConfig[] = [
  MineCourseListRoute,
  OnlineCourseCreateStep1Route,
  OnlineCourseCreateStep2Route,
  CourseLiveDetailRoute,
  CourseLiveStatisticsRoute,
]

export function navigateToMineCourseLiveListPage(router: VueRouter) {
  router.push({
    name: MineCourseListRoute.name,
  })
}

export function navigateToOnlineCourseCreateStep1(
  router: VueRouter,
  backLevel = -1,
  currentStep = '1',
  totalSteps = '2'
) {
  router.push({
    name: OnlineCourseCreateStep1Route.name,
    query: {
      backLevel: String(backLevel),
      currentStep,
      totalSteps,
    },
  })
}

export function navigateToOnlineCourseCreateStep2(router: VueRouter, currentStep = '2', totalSteps = '2') {
  router.push({
    name: OnlineCourseCreateStep2Route.name,
    query: {
      currentStep,
      totalSteps,
    },
  })
}

export function navigateToCourseLiveDetail(router: VueRouter, courseId: string) {
  router.push({
    name: CourseLiveDetailRoute.name,
    query: {
      courseId,
    },
  })
}

export function navigateToCourseLiveStatistics(router: VueRouter) {
  router.push({
    name: CourseLiveStatisticsRoute.name,
  })
}
export default RCourseLive
